import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { confirmEmailAsync } from '@application/features/auth/authThunks';
import { emailConfirmationDestination } from '@application/common/helpers/mail-links';
import { useAppDispatch } from '@application/store/useStore';
import { Alert, Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
const ConfirmEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const confirmationToken = searchParams.get('token');
    const confirmationEmail = searchParams.get('email');
    const [error, setError] = useState('');
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        let active = true;
        setError('');
        if (!confirmationToken || !confirmationEmail) {
            setError('This verification link is incomplete. Please use the complete link in your email.');
            return;
        }
        dispatch(confirmEmailAsync({ email: confirmationEmail, token: confirmationToken.replaceAll(' ', '+') }))
            .unwrap()
            .then(response => {
            if (!active)
                return;
            const destination = emailConfirmationDestination(response);
            if (destination)
                navigate(destination, { replace: true });
            else
                setError('This verification link could not be confirmed. Please check the link or try again.');
        })
            .catch(() => {
            if (active)
                setError('This verification link could not be confirmed. Please check the link or try again.');
        });
        return () => { active = false; };
    }, [confirmationEmail, confirmationToken, dispatch, navigate, attempt]);
    return _jsx(Box, { sx: { maxWidth: 550, mx: 'auto', py: 8, px: 3 }, children: error ? _jsxs(_Fragment, { children: [_jsx(Alert, { severity: 'error', children: error }), confirmationToken && confirmationEmail && _jsx(Button, { onClick: () => setAttempt(value => value + 1), children: "Try again" }), _jsx(Button, { onClick: () => navigate('/login'), children: "Back to sign in" })] }) : _jsx(Typography, { role: 'status', children: "Verifying your email\u2026" }) });
};
export default ConfirmEmail;
